import React, { useState } from "react";
import { useField, useFormikContext } from "formik";

// material
import {
  Container,
  FormControl,
  MenuItem,
  Typography,
  TextField,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";

// ----------------------------------------------------------------------

const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};

export default function UploadFormPage2SecD(props) {
  const formikProps = useFormikContext();
  const [coAuthor, setCoAuthor] = useState("");

  const {
    formField: {
      receivedDateSecD,
      submitDateSecD,
      acceptedDateSecD,
      revisedDateSecD,
      publishedDateSecD,
      articleTitleSecD,
      manuscriptIDSecD,
      typeManuscriptSecD,
      journalSecD,
      subjectAreaCategorySecD,
      journalRankingSecD,
      authorsSecD,
      firstAuthorNameSecD,
      correspondingAuthorNameSecD,
      coauthorAbroadPublicationSecD,
      coauthorNameSecD,
      coResearcherUniversityInstituteNameSecD,
      coResearcherUniversityInstituteRankingSecD,
      supportedSecondCenturyFundSecD,
      uploadManuscriptSecD,
      documentsShowingsSubmissionSecD,
      publicationAcceptedEvidenceSecD,
      attachEvidenceTier1PaperSecD,
      attachEvidenceUniversityInstituteRankingSecD,
      additionalInformNoteSecD,
      additionalDocumentSecD
    }
  } = props;

  const [receivedDateSecDField, receivedDateSecDMeta] =
    useField(receivedDateSecD);
  const [submitDateSecDField, submitDateSecDMeta] = useField(submitDateSecD);
  const [acceptedDateSecDField, acceptedDateSecDMeta] =
    useField(acceptedDateSecD);
  const [revisedDateSecDField, revisedDateSecDMeta] = useField(revisedDateSecD);
  const [publishedDateSecDField, publishedDateSecDMeta] =
    useField(publishedDateSecD);
  const [articleTitleSecDField, articleTitleSecDMeta] =
    useField(articleTitleSecD);
  const [manuscriptIDSecDField, manuscriptIDSecDMeta] =
    useField(manuscriptIDSecD);
  const [typeManuscriptSecDField, typeManuscriptSecDMeta] =
    useField(typeManuscriptSecD);
  const [journalSecDField, journalSecDMeta] = useField(journalSecD);
  const [subjectAreaCategorySecDField, subjectAreaCategorySecDMeta] = useField(
    subjectAreaCategorySecD
  );
  const [journalRankingSecDField, journalRankingSecDMeta] =
    useField(journalRankingSecD);
  const [authorsSecDField, authorsSecDMeta] = useField(authorsSecD);
  const [firstAuthorNameSecDField, firstAuthorNameSecDMeta] =
    useField(firstAuthorNameSecD);
  const [correspondingAuthorNameSecDField, correspondingAuthorNameSecDMeta] =
    useField(correspondingAuthorNameSecD);
  const [
    coauthorAbroadPublicationSecDField,
    coauthorAbroadPublicationSecDMeta
  ] = useField(coauthorAbroadPublicationSecD);
  const [coauthorNameSecDField, coauthorNameSecDMeta] =
    useField(coauthorNameSecD);
  const [
    coResearcherUniversityInstituteNameSecDField,
    coResearcherUniversityInstituteNameSecDMeta
  ] = useField(coResearcherUniversityInstituteNameSecD);
  const [
    coResearcherUniversityInstituteRankingSecDField,
    coResearcherUniversityInstituteRankingSecDMeta
  ] = useField(coResearcherUniversityInstituteRankingSecD);
  const [
    supportedSecondCenturyFundSecDField,
    supportedSecondCenturyFundSecDMeta
  ] = useField(supportedSecondCenturyFundSecD);
  const [uploadManuscriptSecDField, uploadManuscriptSecDMeta] =
    useField(uploadManuscriptSecD);
  const [
    documentsShowingsSubmissionSecDField,
    documentsShowingsSubmissionSecDMeta
  ] = useField(documentsShowingsSubmissionSecD);
  const [
    publicationAcceptedEvidenceSecDField,
    publicationAcceptedEvidenceSecDMeta
  ] = useField(publicationAcceptedEvidenceSecD);
  const [attachEvidenceTier1PaperSecDField, attachEvidenceTier1PaperSecDMeta] =
    useField(attachEvidenceTier1PaperSecD);
  const [
    attachEvidenceUniversityInstituteRankingSecDField,
    attachEvidenceUniversityInstituteRankingSecDMeta
  ] = useField(attachEvidenceUniversityInstituteRankingSecD);
  const [additionalInformNoteSecDField, additionalInformNoteSecDMeta] =
    useField(additionalInformNoteSecD);
  const [additionalDocumentSecDField, additionalDocumentSecDMeta] = useField(
    additionalDocumentSecD
  );

  return (
    <Page title="UploadFormPage2SecD">
      <Container maxWidth="xl">
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {receivedDateSecD.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={receivedDateSecDField.name}
                  value={receivedDateSecDField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        receivedDateSecDField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(
                        receivedDateSecDField.name,
                        date
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        receivedDateSecDMeta.touched &&
                          receivedDateSecDMeta.error
                      )}
                      helperText={
                        receivedDateSecDMeta.touched &&
                        receivedDateSecDMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {submitDateSecD.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={submitDateSecDField.name}
                  value={submitDateSecDField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        submitDateSecDField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(submitDateSecDField.name, date);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        submitDateSecDMeta.touched && submitDateSecDMeta.error
                      )}
                      helperText={
                        submitDateSecDMeta.touched && submitDateSecDMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Stack>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {acceptedDateSecD.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={acceptedDateSecDField.name}
                  value={acceptedDateSecDField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        acceptedDateSecDField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(
                        acceptedDateSecDField.name,
                        date
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        acceptedDateSecDMeta.touched &&
                          acceptedDateSecDMeta.error
                      )}
                      helperText={
                        acceptedDateSecDMeta.touched &&
                        acceptedDateSecDMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {revisedDateSecD.label}
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  name={revisedDateSecDField.name}
                  value={revisedDateSecDField.value}
                  fullWidth
                  onChange={(date) => {
                    if (isValidDate(date)) {
                      formikProps.setFieldValue(
                        revisedDateSecDField.name,
                        date.toISOString()
                      );
                    } else {
                      formikProps.setFieldValue(
                        revisedDateSecDField.name,
                        date
                      );
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={Boolean(
                        revisedDateSecDMeta.touched && revisedDateSecDMeta.error
                      )}
                      helperText={
                        revisedDateSecDMeta.touched && revisedDateSecDMeta.error
                      }
                    />
                  )}
                />
              </LocalizationProvider>
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {publishedDateSecD.label}
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="dd/MM/yyyy"
                name={publishedDateSecDField.name}
                value={publishedDateSecDField.value}
                fullWidth
                onChange={(date) => {
                  if (isValidDate(date)) {
                    formikProps.setFieldValue(
                      publishedDateSecDField.name,
                      date.toISOString()
                    );
                  } else {
                    formikProps.setFieldValue(
                      publishedDateSecDField.name,
                      date
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={Boolean(
                      publishedDateSecDMeta.touched &&
                        publishedDateSecDMeta.error
                    )}
                    helperText={
                      publishedDateSecDMeta.touched &&
                      publishedDateSecDMeta.error
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {articleTitleSecD.label}
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              name={articleTitleSecDField.name}
              value={articleTitleSecDField.value}
              onChange={(e) => articleTitleSecDField.onChange(e)}
              error={Boolean(
                articleTitleSecDMeta.touched && articleTitleSecDMeta.error
              )}
              helperText={
                articleTitleSecDMeta.touched && articleTitleSecDMeta.error
              }
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {manuscriptIDSecD.label}
              </Typography>
              <TextField
                name={manuscriptIDSecDField.name}
                value={manuscriptIDSecDField.value}
                onChange={(e) => manuscriptIDSecDField.onChange(e)}
                error={Boolean(
                  manuscriptIDSecDMeta.touched && manuscriptIDSecDMeta.error
                )}
                helperText={
                  manuscriptIDSecDMeta.touched && manuscriptIDSecDMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {typeManuscriptSecD.label}
              </Typography>
              <TextField
                name={typeManuscriptSecDField.name}
                value={typeManuscriptSecDField.value}
                onChange={(e) => typeManuscriptSecDField.onChange(e)}
                error={Boolean(
                  typeManuscriptSecDMeta.touched && typeManuscriptSecDMeta.error
                )}
                helperText={
                  typeManuscriptSecDMeta.touched && typeManuscriptSecDMeta.error
                }
              />
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{journalSecD.label}</Typography>
            <TextField
              name={journalSecDField.name}
              value={journalSecDField.value}
              onChange={(e) => journalSecDField.onChange(e)}
              error={Boolean(journalSecDMeta.touched && journalSecDMeta.error)}
              helperText={journalSecDMeta.touched && journalSecDMeta.error}
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {subjectAreaCategorySecD.label}
              </Typography>
              <TextField
                name={subjectAreaCategorySecDField.name}
                value={subjectAreaCategorySecDField.value}
                onChange={(e) => subjectAreaCategorySecDField.onChange(e)}
                error={Boolean(
                  subjectAreaCategorySecDMeta.touched &&
                    subjectAreaCategorySecDMeta.error
                )}
                helperText={
                  subjectAreaCategorySecDMeta.touched &&
                  subjectAreaCategorySecDMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {journalRankingSecD.label}
              </Typography>
              <TextField
                select
                variant="outlined"
                name={journalRankingSecDField.name}
                value={journalRankingSecDField.value}
                onChange={(e) => journalRankingSecDField.onChange(e)}
                error={Boolean(
                  journalRankingSecDMeta.touched && journalRankingSecDMeta.error
                )}
                helperText={
                  journalRankingSecDMeta.touched && journalRankingSecDMeta.error
                }
              >
                <MenuItem value={"Tier 1"}>Tier 1</MenuItem>
                <MenuItem value={"Q1"}>Q1</MenuItem>
              </TextField>
            </FormControl>
          </Stack>

          <FormControl fullWidth>
            <Typography variant="subtitle2">{authorsSecD.label}</Typography>
            <TextField
              name={authorsSecDField.name}
              value={authorsSecDField.value}
              onChange={(e) => authorsSecDField.onChange(e)}
              error={Boolean(authorsSecDMeta.touched && authorsSecDMeta.error)}
              helperText={authorsSecDMeta.touched && authorsSecDMeta.error}
            />
          </FormControl>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {firstAuthorNameSecD.label}
              </Typography>
              <TextField
                name={firstAuthorNameSecDField.name}
                value={firstAuthorNameSecDField.value}
                onChange={(e) => firstAuthorNameSecDField.onChange(e)}
                error={Boolean(
                  firstAuthorNameSecDMeta.touched &&
                    firstAuthorNameSecDMeta.error
                )}
                helperText={
                  firstAuthorNameSecDMeta.touched &&
                  firstAuthorNameSecDMeta.error
                }
              />
            </FormControl>

            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {correspondingAuthorNameSecD.label}
              </Typography>
              <TextField
                name={correspondingAuthorNameSecDField.name}
                value={correspondingAuthorNameSecDField.value}
                onChange={(e) => correspondingAuthorNameSecDField.onChange(e)}
                error={Boolean(
                  correspondingAuthorNameSecDMeta.touched &&
                    correspondingAuthorNameSecDMeta.error
                )}
                helperText={
                  correspondingAuthorNameSecDMeta.touched &&
                  correspondingAuthorNameSecDMeta.error
                }
              />
            </FormControl>
          </Stack>

          <Stack direction="row" spacing={6}>
            <FormControl fullWidth>
              <Typography variant="subtitle2">
                {coauthorAbroadPublicationSecD.label}
              </Typography>
              <TextField
                select
                variant="outlined"
                name={coauthorAbroadPublicationSecDField.name}
                value={coauthorAbroadPublicationSecDField.value}
                onChange={(e) => {
                  setCoAuthor(e.target.value);
                  coauthorAbroadPublicationSecDField.onChange(e);
                }}
                error={Boolean(
                  coauthorAbroadPublicationSecDMeta.touched &&
                    coauthorAbroadPublicationSecDMeta.error
                )}
                helperText={
                  coauthorAbroadPublicationSecDMeta.touched &&
                  coauthorAbroadPublicationSecDMeta.error
                }
              >
                <MenuItem value={1}>Yes, I have</MenuItem>
                <MenuItem value={0}>No, I have not</MenuItem>
              </TextField>
            </FormControl>

            {coAuthor === 1 && (
              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {coauthorNameSecD.label}
                </Typography>
                <TextField
                  placeholder="e.g. Professor Dr. Richard"
                  name={coauthorNameSecDField.name}
                  value={coauthorNameSecDField.value}
                  onChange={(e) => coauthorNameSecDField.onChange(e)}
                  error={Boolean(
                    coauthorNameSecDMeta.touched && coauthorNameSecDMeta.error
                  )}
                  helperText={
                    coauthorNameSecDMeta.touched && coauthorNameSecDMeta.error
                  }
                />
              </FormControl>
            )}
          </Stack>

          {coAuthor === 1 && (
            <Stack direction="row" spacing={6}>
              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {coResearcherUniversityInstituteNameSecD.label}
                </Typography>
                <TextField
                  name={coResearcherUniversityInstituteNameSecDField.name}
                  value={coResearcherUniversityInstituteNameSecDField.value}
                  onChange={(e) =>
                    coResearcherUniversityInstituteNameSecDField.onChange(e)
                  }
                  error={Boolean(
                    coResearcherUniversityInstituteNameSecDMeta.touched &&
                      coResearcherUniversityInstituteNameSecDMeta.error
                  )}
                  helperText={
                    coResearcherUniversityInstituteNameSecDMeta.touched &&
                    coResearcherUniversityInstituteNameSecDMeta.error
                  }
                  placeholder="e.g. Cambridge University"
                />
              </FormControl>

              <FormControl fullWidth>
                <Typography variant="subtitle2">
                  {coResearcherUniversityInstituteRankingSecD.label}
                </Typography>
                <TextField
                  select
                  variant="outlined"
                  name={coResearcherUniversityInstituteRankingSecDField.name}
                  value={coResearcherUniversityInstituteRankingSecDField.value}
                  onChange={(e) =>
                    coResearcherUniversityInstituteRankingSecDField.onChange(e)
                  }
                  error={Boolean(
                    coResearcherUniversityInstituteRankingSecDMeta.touched &&
                      coResearcherUniversityInstituteRankingSecDMeta.error
                  )}
                  helperText={
                    coResearcherUniversityInstituteRankingSecDMeta.touched &&
                    coResearcherUniversityInstituteRankingSecDMeta.error
                  }
                >
                  <MenuItem value={"Top 100 University_(QS or THE)"}>
                    Top 100 University_(QS or THE)
                  </MenuItem>
                  <MenuItem value={"Top 100 subject University_(QS or THE)"}>
                    Top 100 subject University_(QS or THE)
                  </MenuItem>
                  <MenuItem value={"Top institute"}>Top institute</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </TextField>
              </FormControl>
            </Stack>
          )}

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {supportedSecondCenturyFundSecD.label}
            </Typography>
            <TextField
              select
              variant="outlined"
              name={supportedSecondCenturyFundSecDField.name}
              value={supportedSecondCenturyFundSecDField.value}
              onChange={(e) => supportedSecondCenturyFundSecDField.onChange(e)}
              error={Boolean(
                supportedSecondCenturyFundSecDMeta.touched &&
                  supportedSecondCenturyFundSecDMeta.error
              )}
              helperText={
                supportedSecondCenturyFundSecDMeta.touched &&
                supportedSecondCenturyFundSecDMeta.error
              }
            >
              <MenuItem value={"Yes, I do."}>Yes, I do.</MenuItem>
              <MenuItem value={"No, I do not."}>No, I do not.</MenuItem>
            </TextField>
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {uploadManuscriptSecD.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={uploadManuscriptSecDField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `uploadManuscriptSecD.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                uploadManuscriptSecDMeta.touched &&
                  uploadManuscriptSecDMeta.error
              )}
              helperText={
                uploadManuscriptSecDMeta.touched &&
                uploadManuscriptSecDMeta.error
              }
            />
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {documentsShowingsSubmissionSecD.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={documentsShowingsSubmissionSecDField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `documentsShowingsSubmissionSecD.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                documentsShowingsSubmissionSecDMeta.touched &&
                  documentsShowingsSubmissionSecDMeta.error
              )}
              helperText={
                documentsShowingsSubmissionSecDMeta.touched &&
                documentsShowingsSubmissionSecDMeta.error
              }
            />
            <Typography>
              For those who have already submitted a research paper, but have
              not accepted yet.
            </Typography>
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {publicationAcceptedEvidenceSecD.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={publicationAcceptedEvidenceSecDField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `publicationAcceptedEvidenceSecD.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                publicationAcceptedEvidenceSecDMeta.touched &&
                  publicationAcceptedEvidenceSecDMeta.error
              )}
              helperText={
                publicationAcceptedEvidenceSecDMeta.touched &&
                publicationAcceptedEvidenceSecDMeta.error
              }
            />
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {attachEvidenceTier1PaperSecD.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={attachEvidenceTier1PaperSecDField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `attachEvidenceTier1PaperSecD.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                attachEvidenceTier1PaperSecDMeta.touched &&
                  attachEvidenceTier1PaperSecDMeta.error
              )}
              helperText={
                attachEvidenceTier1PaperSecDMeta.touched &&
                attachEvidenceTier1PaperSecDMeta.error
              }
            />
          </FormControl>

          {coAuthor === 1 && (
            <FormControl>
              <Typography variant="subtitle2">
                {attachEvidenceUniversityInstituteRankingSecD.label}
              </Typography>
              <TextField
                inputProps={{
                  accept:
                    "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
                }}
                type="file"
                name={attachEvidenceUniversityInstituteRankingSecDField.name}
                onChange={(event) => {
                  formikProps.setFieldValue(
                    `attachEvidenceUniversityInstituteRankingSecD.file`,
                    event.currentTarget.files[0]
                  );
                }}
                error={Boolean(
                  attachEvidenceUniversityInstituteRankingSecDMeta.touched &&
                    attachEvidenceUniversityInstituteRankingSecDMeta.error
                )}
                helperText={
                  attachEvidenceUniversityInstituteRankingSecDMeta.touched &&
                  attachEvidenceUniversityInstituteRankingSecDMeta.error
                }
              />
            </FormControl>
          )}

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {additionalInformNoteSecD.label}
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              name={additionalInformNoteSecDField.name}
              value={additionalInformNoteSecDField.value}
              onChange={(e) => additionalInformNoteSecDField.onChange(e)}
              error={Boolean(
                additionalInformNoteSecDMeta.touched &&
                  additionalInformNoteSecDMeta.error
              )}
              helperText={
                additionalInformNoteSecDMeta.touched &&
                additionalInformNoteSecDMeta.error
              }
            />
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2">
              {additionalDocumentSecD.label}
            </Typography>
            <TextField
              inputProps={{
                accept:
                  "image/x-png,image/gif,image/jpeg,.doc,.docx,application/pdf"
              }}
              type="file"
              name={additionalDocumentSecDField.name}
              onChange={(event) => {
                formikProps.setFieldValue(
                  `additionalDocumentSecD.file`,
                  event.currentTarget.files[0]
                );
              }}
              error={Boolean(
                additionalDocumentSecDMeta.touched &&
                  additionalDocumentSecDMeta.error
              )}
              helperText={
                additionalDocumentSecDMeta.touched &&
                additionalDocumentSecDMeta.error
              }
            />
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
